import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, StaffelUnit } from "__generated__/graphql";

export const GasolineSchema: RegistryItem = {
	[AgreementTypeEnum.Gasoline]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Staffel,
				staffelUnit: StaffelUnit.Gasoline,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
